import React from "react";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import logoWhite from "../components/img/logo-white.svg";
import { api } from "../components/utils/JWTAuth";
class CambiarPassword extends React.Component {
	handleChangePass = (event) => {
		event.preventDefault();

		var password1 = 0;
		var password2 = 0;
		var formcheckboxTYC = 0;

		if (event.target.password1.value === "") {
			password1 = "Password01 vacio";
		} else if (event.target.password2.value === "") {
			password2 = "Password02 vacio";
		} else if (event.target.formcheckboxTYC.value === "") {
			password2 = "Password02 vacio";
		}
		if (password1 !== 0 || password2 !== 0 || formcheckboxTYC !== 0) {
			alert("Hay campos obligatorios sin rellenar");
		} else if (event.target.password1.value !== event.target.password2.value) {
			alert("Las contraseñas no son iguales");
		} else {
			if (event.target.password1.value.length >= 8) {
				if (/[^0-9a-zA-Z]/.test(event.target.password1.value)) {
					alert(
						"La contraseña introducida contiene caracteres no permitidos. Recuerde que la contraseña solo puede contener numeros y letras."
					);
				} else {
					let formData = new FormData();
					formData.append("code", this.props.match.params.tokkenPSW);
					formData.append("passw", event.target.password1.value);
					api
						.post("/users_restore_passw", formData)
						.then((response) => {
							//console.log(res);

							alert("Su contraseña se ha modificado correctamente.");
							this.props.history.push({
								pathname: "/login",
							});
						})
						.catch((error) => {
							alert(
								"No se ha podido reestablecer la contraseña por motivos técnicos, vuelva a solicitarla más tarde"
							);
						});
				}
			} else {
				alert("La contraseña tiene que tener por lo menos 8 caracteres.");
			}
			/*
			let formData = new FormData();
			formData.append("code", this.props.match.params.tokkenPSW);
			formData.append("passw", event.target.password1.value);
			api
				.post("/users_restore_passw", formData)
				.then((response) => {
					//console.log(res);
					console.log(response);
					alert("Su contraseña se ha modificado correctamente.");
					this.props.history.push({
						pathname: "/login",
					});
				})
				.catch((error) => {
					alert("No se ha podido reestablecer la contrasña");
				});
				*/
		}
	};
	render() {
		return (
			<div>
				<hr className="whiteSpace"></hr>
				<Container className="width-100 nopadding maxWidth-100 ">
					<Row>
						<Col md={5} sm={12}>
							<div className="align-items-center h-sm-100-vh d-flex bg-grad-blue ">
								<div className="width-100 textWhite login-padding">
									<img src={logoWhite} alt="Fes login logo" width="230px"></img>
									<h2 className="textWhite">Únete a FES para estar al dia.</h2>
									<div className="listCheck" hidden>
										<ul>
											<li>Punto 1</li>
											<li>Punto 2</li>
											<li>Punto 3</li>
										</ul>
									</div>
								</div>
							</div>
						</Col>
						<Col md={7} sm={12}>
							<div className="align-items-center h-sm-100-vh d-flex mx-auto form-login">
								<div className="width-100  login-padding ">
									<h2>Nueva Contraseña</h2>
									<p>Escriba la nueva contraseña para su cuenta</p>
									<div className="listCheck">
										<Form onSubmit={this.handleChangePass}>
											<Form.Group
												controlId="password01"
												className="fieldUnderText"
											>
												<Form.Label>Nueva Contraseña</Form.Label>
												<Form.Control
													type="password"
													placeholder="Contraseña"
													name="password1"
													required
												/>
											</Form.Group>
											<p className="smallTextExplanation">
												La contraseña debe tener al menos 8 caracteres y
												contener solo letras y números.
											</p>
											<Form.Group controlId="password02">
												<Form.Label>Repetir Contraseña</Form.Label>
												<Form.Control
													type="password"
													placeholder="Contraseña"
													name="password2"
													required
												/>
											</Form.Group>

											<Form.Group controlId="formcheckboxTYC">
												<Form.Check
													type="checkbox"
													value="1"
													name="formcheckboxTYC"
													label={
														<label>
															<a
																href="https://fes-sociologia.com/uploads/privacy/Politica_de_privacidad.pdf"
																target="_blank"
																rel="noopener noreferrer"
															>
																Acepto los terminos y condiciones
															</a>
														</label>
													}
													required
												/>
											</Form.Group>

											<p>
												¿Ya tienes una cuenta?{" "}
												<a href="/login">Acceder ahora</a>
												<br></br>
												¿Aun no tienes una cuenta?
												<a href="/registro">Registrar cuenta</a>
											</p>
											<Button
												variant="primary"
												type="submit"
												className="Acceder"
											>
												Cambiar
											</Button>
										</Form>
									</div>
								</div>
							</div>
						</Col>
					</Row>
				</Container>
			</div>
		);
	}
}
export default CambiarPassword;
